export const environment = {
  production: true,
  apiUrl: 'https://globalassethub.sonypictures.com/gahapi',
  baseUrl: 'https://globalassethub.sonypictures.com',
  stripoPluginStaticSource: 'https://plugins.stripo.email/static/latest/stripo.js',
  stripoPluginAuth : 'https://plugins.stripo.email/api/v1/auth',
  okta: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa14tms8t6U0KIsO358',
    redirectUri: 'https://globalassethub.sonypictures.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://globalassethub.sonypictures.com'
  },
  oktapublicity: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa14tms8t6U0KIsO358',
    redirectUri: 'https://www.sonypicturespublicity.net/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespublicity.net'
  },
  oktapublicityaus: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa14tms8t6U0KIsO358',
    redirectUri: 'https://www.sonypicturespublicity.com.au/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespublicity.com.au'
  },
  oktapublicitydotcom: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa14tms8t6U0KIsO358',
    redirectUri: 'https://www.sonypicturespublicity.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespublicity.com'
  },
  oktapublicityfr: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa14tms8t6U0KIsO358',
    redirectUri: 'https://www.sonypicturespresse.fr/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespresse.fr'
  },
  oktapublicitynz: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa14tms8t6U0KIsO358',
    redirectUri: 'https://www.sonypicturespublicity.co.nz/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespublicity.co.nz'
  },
  oktapublicity1: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa14tms8t6U0KIsO358',
    redirectUri: 'https://sonypicturespublicity.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://sonypicturespublicity.com'
  },
  captchaSiteKey: '6Ld-pmQpAAAAAJJmZQ0o-qgDcvvrw9gygc6KuXBG',
  gtmId: 'GTM-KXZMHDG',
  gtmId_ns: 'GTM-KXZMHDG',
  gtmScriptUrl: 'https://www.googletagmanager.com/gtm.js',
  gtmNoScriptUrl: 'https://www.googletagmanager.com/ns.html'
};